import { render, staticRenderFns } from "./galleryList.vue?vue&type=template&id=a92007fa&scoped=true&"
import script from "./galleryList.vue?vue&type=script&lang=js&"
export * from "./galleryList.vue?vue&type=script&lang=js&"
import style0 from "./galleryList.vue?vue&type=style&index=0&id=a92007fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92007fa",
  null
  
)

export default component.exports